import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import qs from "query-string";
import { useLocation } from "react-router-dom";

export const useContactStrategy = () => {
  const location = useLocation();
  const retailerToken = getRetailerToken();
  const brandToken = getBrandToken();

  const isUserLoggedIn = (): boolean => {
    return !!retailerToken || !!brandToken;
  };
  const locationSearch = (): qs.ParsedQuery => {
    return qs.parse(location?.search ?? "");
  };
  const isLoggedOutExperience = (): boolean => {
    return !!locationSearch().loggedOut;
  };
  const shouldShowContactModal = (): boolean => {
    return !!locationSearch().contact;
  };

  return {
    isUserLoggedIn,
    isLoggedOutExperience,
    shouldShowContactModal,
  };
};
